
export default function SectorsSection() {
  const sectors = [
    {
      icon: 'ri-line-chart-line',
      title: 'Financial Advisory',
      description: 'Comprehensive financial structuring, M&A advisory, and capital markets expertise for complex transactions',
      capabilities: [
        'Mergers & Acquisitions',
        'Capital raising strategy',
        'Financial modeling & valuation',
        'Due diligence coordination',
        'Deal structuring & negotiation'
      ]
    },
    {
      icon: 'ri-government-line',
      title: 'Government Relations',
      description: 'Deep understanding of policy frameworks and regulatory environments across Southern Africa',
      capabilities: [
        'Policy advocacy & reform',
        'Regulatory compliance navigation',
        'Public-private partnerships',
        'Stakeholder engagement',
        'License & permit acquisition'
      ]
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Energy',
      description: 'Renewable and conventional energy project development and strategic advisory',
      capabilities: [
        'Solar & wind project development',
        'Power purchase agreements',
        'Grid integration planning',
        'Energy transition strategy',
        'Regulatory framework navigation'
      ]
    },
    {
      icon: 'ri-oil-line',
      title: 'Oil & Gas',
      description: 'Upstream, midstream, and downstream sector expertise in Mozambique\'s emerging LNG market',
      capabilities: [
        'Project feasibility studies',
        'PSA & contract negotiation',
        'Local content development',
        'Environmental & social impact',
        'Supply chain optimization'
      ]
    },
    {
      icon: 'ri-hammer-line',
      title: 'Mining',
      description: 'Mining project development, from exploration through production and export',
      capabilities: [
        'Mining license acquisition',
        'Resource estimation & valuation',
        'Infrastructure requirements',
        'Community relations',
        'Export logistics planning'
      ]
    },
    {
      icon: 'ri-building-line',
      title: 'Infrastructure',
      description: 'Large-scale infrastructure development including transport, utilities, and urban projects',
      capabilities: [
        'PPP structuring & financing',
        'Concession agreements',
        'Technical feasibility',
        'Multi-stakeholder coordination',
        'Construction management'
      ]
    },
    {
      icon: 'ri-truck-line',
      title: 'Logistics & Distribution',
      description: 'Supply chain optimization and logistics network development for regional trade',
      capabilities: [
        'Port & corridor development',
        'Warehouse network design',
        'Cold chain infrastructure',
        'Customs & border efficiency',
        'Last-mile distribution'
      ]
    },
    {
      icon: 'ri-megaphone-line',
      title: 'Corporate Communications',
      description: 'Strategic communication and stakeholder management for complex project environments',
      capabilities: [
        'Crisis communication management',
        'Media relations strategy',
        'Community engagement programs',
        'Corporate reputation building',
        'CSR & sustainability reporting'
      ]
    }
  ];

  return (
    <section id="sectors" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-light mb-6" style={{ color: '#50686a' }}>
            Sectors
          </h2>
          <p className="text-lg font-light max-w-3xl mx-auto" style={{ color: '#607a7a' }}>
            We provide specialized expertise across key sectors driving economic growth in Mozambique and Southern Africa
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {sectors.map((sector, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full" style={{ backgroundColor: '#50686a' }}>
                <i className={`${sector.icon} text-2xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-medium mb-3 text-center" style={{ color: '#50686a' }}>
                {sector.title}
              </h3>
              
              <p className="text-sm font-light mb-4 text-center" style={{ color: '#607a7a' }}>
                {sector.description}
              </p>
              
              <div className="border-t pt-4" style={{ borderColor: '#e5e7eb' }}>
                <h4 className="text-sm font-medium mb-2" style={{ color: '#50686a' }}>
                  Key Capabilities:
                </h4>
                <ul className="space-y-1">
                  {sector.capabilities.map((capability, capIndex) => (
                    <li key={capIndex} className="text-xs font-light flex items-start" style={{ color: '#607a7a' }}>
                      <span className="w-1 h-1 rounded-full mt-2 mr-2 flex-shrink-0" style={{ backgroundColor: '#98b8c1' }}></span>
                      {capability}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
